<div class="card mt-4">
  <div class="card-body">
    <p-table [value]="notifications" [loading]="loadingNotifications" [scrollable]="true"
    scrollHeight="400px">
      <ng-template pTemplate="header">
        <tr>
          <th>Reminder Notes</th>
          <th>Notification Date & Time</th>
          <th>Mark as Read</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-notification>
        <tr>
          <td>{{ notification.commentText }}</td>
          <td>{{ notification.createdOn | date:'MM/dd/yyyy HH:mm' }}</td>
          <td>
            <button type="button" class="btn btn-success btn-sm me-1" title="Mark as Read"
              [disabled]="notification.read"
              (click)="markAsRead(notification)">
              <i class="mdi mdi-check"></i>
            </button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="text-center">
            No notifications found.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
